// extracted by mini-css-extract-plugin
export default {"button":"Button_button__KXFVC","border_button":"Button_border_button__QrBds"};